import { render, staticRenderFns } from "./mgFormInput.vue?vue&type=template&id=325f2a47&scoped=true&"
import script from "./mgFormInput.vue?vue&type=script&lang=js&"
export * from "./mgFormInput.vue?vue&type=script&lang=js&"
import style0 from "./mgFormInput.vue?vue&type=style&index=0&id=325f2a47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f2a47",
  null
  
)

export default component.exports